<template>
  <div class="membership-point-transection-wrap">
    <loading v-if="loadingTransection" />
    <template v-else>
      <div class="loyality-point-transection-history customscrollbar body-text-dark-" v-if="loyalityTransections.length > 0">
        <h2 class="has-text-weight-bold is-size-4 font-color has-text-centered pb10">Point Transaction History</h2>
        <item v-for="record in loyalityTransections" :record="record" v-bind:key="record.id"/> 
      </div>
      <div class="loyality-point-transection-history body-text-dark-" v-else>
        <h2 class="has-text-weight-bold is-size-4 font-color has-text-centered pb10">Point Transaction History</h2>
        <p class="has-text-centered mt10">Sorry no record found.</p>
      </div>
    </template>
  </div>
</template>


<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import { format } from "date-fns";
import UserApis from '@/Components/Controllers/UserApis';
import Item from '@/Components/Pages/User/Membership/TransactionHistoryItem';

export default {
  components: {
    Item,
  },
  data() {
    return {
      loadingTransection: false,
      loyalityTransections: [],
    }
  },
  
  computed: {

    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
    })
  },
  

  async mounted() {
    this.loadingTransection = true;
    let res = await UserApis.getUserLoyaltyTransactions({
      business_id: this.vg_businessProfile.id,
      page: 1,
      limit: 25
    });
    if(res.status == 200){
      this.loyalityTransections = res.data.payload.results.filter( item => (item.points_redeemed || item.points_earned) );
    }
    this.loadingTransection = false;
  },

  methods: {
   
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>
